/**
 * Các loại hiển thị popup chọn đơn vị
 */
export default {
  None: 0,
  Department: 1,
  Organization: 2,
};
